<div lazy-load-images>
  <router-outlet></router-outlet>
</div>

<app-game-iframe *appShellNoSSR></app-game-iframe>

<ng-container *appShellNoSSR>
  <app-toast-message></app-toast-message>
  @if (installAppVisible) {
    <app-install-app-banner></app-install-app-banner>
  }
</ng-container>

@defer (when isMobile()) {
  @if (stickyMenuVisible && !gamesFilters.isFiltersOpen) {
    <app-sticky-menu></app-sticky-menu>
  }
}
